import './image.scss';

import Swiper, { Pagination, Navigation } from 'swiper';

class Image {
    constructor ($element) {
        this.$imageSlider = $element;
        this.$slides = this.$imageSlider.querySelectorAll('[data-image-slider="slide"]');
        this.slider = null;
    }

    initialize () {
        if (this.$slides.length > 1) {
            this.initSlider();
        }
    }

    initSlider () {
        let startSlide = 1;
        let slideCentered = true;
        if (this.$slides.length === 2) {
            startSlide = 0;
            slideCentered = false;
        }
        Swiper.use([Pagination]);
        Swiper.use([Navigation]);
        this.slider = new Swiper(this.$imageSlider, {
            slidesPerView: 'auto',
            spaceBetween: 0,
            centeredSlides: true,
            initialSlide: startSlide,
            speed: 1000,
            slideClass: 'image__images-item',
            wrapperClass: 'image__images-inner',
            pagination: {
                el: '.image__images-pagination',
                type: 'progressbar'
            },
            navigation: {
                nextEl: '.image__images-button-next',
                prevEl: '.image__images-button-prev'
            },
            breakpoints: {
                768: {
                    centeredSlides: slideCentered
                }
            },
            on: {
                slideChangeTransitionStart: () => {
                    const $progressBar = this.$imageSlider.querySelector('.slider-pagination');
                    $progressBar.classList.add('is--active');
                },
                slideChangeTransitionEnd: () => {
                    const $progressBar = this.$imageSlider.querySelector('.slider-pagination');
                    $progressBar.classList.remove('is--active');
                }
            }
        });
    }
}

export { Image };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $imageSliders = $context.querySelectorAll('[data-image-slider="root"]');
        if ($imageSliders.length > 0) {
            $imageSliders.forEach((imageSlider) => {
                const $imageSlider = new Image(imageSlider);
                $imageSlider.initialize();
            });
        }
    }
});
